<template>
    <div class="send-mail">
        <div class="send-mail-title">
            <span class="" @click="linkTo">写邮件</span>
        </div>
         <div v-loading="loading.status" :element-loading-text="loading.txt">
            <div class="send-mail-main">
                <el-form :model="sendForm" :rules="rules" ref="sendForm" label-width="100px" class="demo-send-form">
                    <el-form-item label="收件人" prop="recipients" class="send-form-recipients">
                        <div v-if="recipientList.length > 0">
                            <span v-for="(item, index) in recipientList" :key="index">
                                {{item.name}}<i class="el-icon-error" @click="clearReceiver(index)"></i><span>；</span>
                            </span>
                        </div>
                        <div v-else>选择收件人</div>
                        <div class="send-form-reciver">
                            <span @click="show_recipic = !show_recipic">{{show_recipic ? '隐藏外部收件人' : '添加外部收件人'}}</span>
                            <span @click="show_cc = !show_cc">{{show_cc ? '隐藏抄送' : '显示抄送'}}</span>
                        </div>
                        <div class="send-form-btn">
                            <span @click="addFormRecipient">添加收件人</span>
                            <span @click="clearRecipient">清空</span>
                        </div>
                        <el-input v-model="sendForm.recipients" v-show="false"></el-input>
                    </el-form-item>

                    <el-form-item label="抄送" v-show="show_cc">
                        <div v-if="ccList.length > 0" class="send-form-cc">
                            <span v-for="(item, index) in ccList" :key="index">
                                {{item.name}}<i class="el-icon-error" @click="clearCC(index)"></i><span>；</span>
                            </span>
                        </div>
                        <div v-else class="send-form-cc">选择收件人</div>
                        <div class="send-form-btn">
                            <span @click="addFormRecipient('cc')">添加收件人</span>
                            <span @click="clearRecipient('cc')">清空</span>
                        </div>
                    </el-form-item>

                    <el-form-item label="外部收件人" v-show="show_recipic">
                        <el-input 
                            id="external_recipient" 
                            v-model="sendForm.externalRecipient" 
                            @blur="blurExternalRecipient" 
                            placeholder="输入正确的邮箱格式，用中文或英文 , 隔开">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="Internet邮箱" v-show="show_recipic" class="send-form-internet">
                        <el-select v-if="internetList.length > 0" v-model="sendForm.internetMail" placeholder="请选择邮箱">
                            <el-option v-for="(item, index) in internetList" :key="index" :label="item.account" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-else v-model="sendForm.internetMail" placeholder="请至邮箱设置中设置Internet邮箱">
                            <el-option v-for="(item, index) in internetList" :key="index" :label="item.account" :value="item.id"></el-option>
                        </el-select>
                        <span>通过该邮箱发邮件给外部收件人</span>
                    </el-form-item>
                    
                    <el-form-item label="邮件主题" prop="subject">
                        <el-input v-model="sendForm.subject" maxlength="40" placeholder="40个字符以内"></el-input>
                    </el-form-item>
                    <el-form-item label="邮件内容" prop="post_content" class="mail-content">
                        <tinymce
                            id="d1"
                            ref="tm"
                            :plugins="plugins"
                            :other_options="tinymceOptions"
                            :toolbar1="toolbar1"
                            :toolbar2="toolbar2"
                            @editorInit="editorInit"
                            v-model="sendForm.post_content">
                        </tinymce>
                        <div class="tinymce-num">{{tinymceNum}} / 10000</div>
                    </el-form-item>

                    <el-form-item label="附件">
                        <span v-if="sendForm.attachment.length === 0" class="no-attachment">无附件</span>
                        <div v-else class="send-form-attachment-list">
                            <span v-for="(item, index) in sendForm.attachment" :key="index">
                                <img src="./../../../assets/email/images/attachment.png" />
                                <span>{{item.name}}</span>
                                <i class="el-icon-error" @click="delAttachment(item.name)"></i>
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="附件">
                        <uploader
                            class="uploader-example"
                            ref="uploader"
                            :options="uploadOptions"
                            :file-status-text="statusText"
                            @file-added="fileAdded"
                            @files-submitted="fileSubmit"
                            @file-progress="fileProgress"
                            @file-removed="fileRemoved"
                            @file-success="fileSuccess"
                            @file-error="fileFail">
                            <uploader-unsupport></uploader-unsupport>
                            <uploader-btn :directory="false" :single="true" v-if="sendForm.attachment.length < 3 && !disabledUplader">上传附件</uploader-btn>
                            <el-button v-else class="disabled-uploader" disabled>上传附件</el-button>
                            <div :class="progressing ? 'uploader-progress-active' : 'uploader-progress'">
                                <div>
                                    <el-progress :percentage="percentage" color="#33BBBB"></el-progress>
                                    <span @click="fileCancel">取消</span>
                                </div>
                            </div>
                        </uploader>
                    </el-form-item>
                </el-form>
            </div>

            <div class="send-mail-footer">
                <span @click="submitDrafts"><img src="./../../../assets/email/images/save.png" />保存至草稿箱</span>
                <span @click="submitMail('sendForm')"><img src="./../../../assets/email/images/mail.png" />发送邮件</span>
            </div>
        </div>

        <el-dialog 
            title="选择人员" 
            :visible.sync="pop_up" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :before-close="closeRecipient"
            class="common-mail-dialog add-recipients-dialog" 
            width="850px">
            <div class="el-dialog-pop-up">
                <div>
                    <div>
                        <el-select v-model="plaformId" placeholder="请选择">
                            <el-option
                                v-for="(item, index) in plaformList"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="org-people-box">
                        <div id="scrollReceiver">
                            <div class="org-people-item" v-for="(item, index) in receiverList" :key="index">
                                <span>{{index+1}}.{{item.name}}</span>
                                <span v-html="showRoleName(item.role_name)"></span>
                                <span @click="addRecipient(index)">添加</span>
                            </div>
                        </div>
                        <p @click="addAllRecipient">全部添加</p>
                    </div>
                </div>
                <div>
                    <div class="el-dialog-pop-keyword">
                        <el-input v-model="receiver_keyword" placeholder="用户姓名"></el-input>
                        <el-button type="primary" @click="getReceiverData('search')">搜索</el-button>
                    </div>
                    <div class="el-show-pepole">
                        <div>
                            <div>
                                <span></span>
                                <span>账号</span>
                                <span>用户名</span>
                                <span>角色</span>
                                <span>所属组织</span>
                            </div>
                            <template v-if="people_lsit.length > 0">
                                <div v-for="(item, index) in people_lsit" :key="index">
                                    <span @click="deleteRecipient(index)">
                                        <i class="el-icon-error"></i>
                                    </span>
                                    <span>{{item.number}}</span>
                                    <span>{{item.name}}</span>
                                    <span v-html="showRoleName(item.role_name)"></span>
                                    <span>{{item.platform_name}}</span>
                                </div>
                            </template>
                        </div>
                        <p @click="people_lsit = []">全部移除</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" size="small" plain @click="closeRecipient">取 消</el-button>
                <el-button type="primary" size="small" @click="newRecipient">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from '../../../tools/axios';
    import tinymce from "vue-tinymce-editor";
    import {networkMailbox} from './../base/base.js';
    import CHINESE from '../../../assets/tinymce_languages/zh_CN.js';

    export default {
        data() {
            return {
                receiverCount: 0,
                isSend: false, // 不可以发送邮件
                show_cc: false, // 显示抄送收件人
                pop_up: false, // 弹出收件人窗口
                show_recipic: false, // 显示外部收件人
                progressing: false, // 是否正在上传附件
                disabledUplader: false, // 上传附件过程中，不可以在上传
                isExternalRecipient: false, // 外部邮箱输入是否正确
                mailId: null, // 第一次定时保存后返回的邮件 id
                intervalTime: null,
                home_header: null, // html dom
                home_main: null, // html dom
                plaformId: null, // 收件人的组织架构
                uploadRetryTimes: 10, // 上传附件失败重新上传次数
                percentage: 0, // 附件上传进度
                tinymceNum: 0,
                receiver_keyword: '', // 收件人搜索关键字
                recipientCC: '', // 是否为抄送人
                toolbar1: "paste,fullscreen,link", // 编辑器工具栏
                toolbar2: "formatselect  | fontsizeselect | forecolor backcolor | fontselect bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | removeformat", // 编辑器工具栏
                internetList: [], // 网络邮箱
                people_lsit: [], // 选中的收件人
                ccList: [], // 选中的抄送人列表
                recipientList: [], // 选中的收件人列表
                plugins: ["paste", "fullscreen", "link"], // 编辑器插件
                plaformList: [], // 平台列表
                receiverList: [], // 收件人列表
                loading:{
					status:false,
					txt:'保存数据...',
				},
                receiverParam: { // 收件人列表参数
                    page_index: 1,
                    page_size: 10
                },
                sendForm: { // 邮件表单
                    recipients: '',
                    cc: '',
                    externalRecipient: '',
                    internetMail: null,
                    subject: '',
                    post_content: '',
                    attachment: []
                },
                uploadOptions: { // 上传参数
                    target: this.BASE_URL + "/api/resource/res_upload",
                    testChunks: false,
                    headers: {Authorization: `Bearer ` + this.$g.access_token}
                },
                statusText: { // 上传状态
                    success: "上传成功",
                    error: "上传出错",
                    uploading: "正在上传...",
                    paused: "暂停",
                    waiting: "等待上传"
                },
                tinymceOptions: { // 编辑器参数
                    // images_upload_handler: this.images_upload_handler,
                    language_url: CHINESE,
                    // images_upload_url: this.BASE_URL + "/api/resource/res_upload",
                    paste_data_images: false, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
                    paste_convert_word_fake_lists: false, // 插入word文档需要该属性
                    paste_webkit_styles: "all",
                    paste_merge_formats: true,
                    nonbreaking_force_tab: false,
                    paste_auto_cleanup_on_paste: true, // 去掉文本里的样式
                    paste_preprocess: (plugin, args) => {
                        args.content = this.strip_tags(args.content);
                    }
                },
                rules: { // 表单规则验证
                    recipients: [
                        { required: true, message: '请输入收件人', trigger: 'change' }
                    ],
                    subject: [
                        { required: true, message: '请输入邮件主题', trigger: 'blur' }
                    ],
                    post_content: [
                        { required: true, message: '请输入邮件正文内容', trigger: 'blur' }
                    ]
                },
                isScroll: true,
                scrollT: 0,
            }
        },
        created() {
            this.getInternetList();
            this.getPlaformList();
        },
        mounted() {
            this.setStyle();
            this.setTimers();
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.scrollFun, false);
        },
        watch: {
            'sendForm.externalRecipient'(newVal, oldVal) {
                let str = newVal.split(/[,，]/g);
                
                if (str.length === 21) {
                    this.sendForm.externalRecipient = oldVal;
                    this.$message.warning('外部收件人最多可添加20个账号');
                }
            },
            'sendForm.post_content'(newVal, oldVal) {
                setTimeout(() => {
                    let body = document.getElementById('d1_ifr').contentWindow.document.getElementsByTagName('body')[0].textContent;
                    let newLen = body.replace(/\s/g, '').length;
                    let oldLen = this.tinymceNum;

                    // 判断邮件长度是否超过 10000
                    if (newLen > 10000) {
                        this.$message.warning('邮件最大长度不可以超过 10000 个字');
                        this.tinymceNum = oldLen;
                        this.sendForm.post_content = oldVal;
                    } else {
                        this.tinymceNum = newLen;
                    }
                }, 300);
            }
        },
        components: {
            tinymce
        },
        methods: {
            strip_tags (str){
                //对img标签进行匹配
                let imgReg = /<img.*?(?:>|\/>)/gi;
                
                if(imgReg.test(str)) {
                    //将img标签替换为*
                    str =  str.replace(imgReg, "");
                }
                
                //处理html标签
                // mainContent =  mainContent.replace(/&nbsp;/gi," ");
                return str;
            },
            /**
             * 显示全部角色
             * @param {Array} arr 角色
             */
            showRoleName(arr) {
                let name = arr ? arr.join('</br>') : '';
                return name;
            },
            /**
             * 获取平台列表
             */
            getPlaformList() {
                let success = (res => {
                    this.plaformList = res.data;

                    if (this.plaformList.length > 0) {
                        this.plaformId = this.plaformList[0].id;
                        this.receiver_keyword = null;
                        this.receiverParam = {
                            page_index: 1,
                            page_size: 10
                        }
                        this.getReceiverList();
                    }
                });

                this.$ajax({
                    url: "api/email/platform",
                    method: "get",
                    params: {},
                    func: {success: success}
                });
            },
            /**
             * 
             */
            scrollFun(event) {
                event = event || window.event;
                let target = event.target;
                let scrollH = target.scrollHeight - target.scrollTop - target.clientHeight;
                
                if (
                    this.scrollT < target.scrollTop
                    && scrollH < 20 
                    && this.isScroll 
                    && Math.ceil(this.receiverCount/this.receiverParam.page_size) > this.receiverParam.page_index) {
                    this.isScroll = false;
                    this.receiverParam.page_index++;
                    this.getReceiverData('scroll');
                }

                this.scrollT = target.scrollTop
            },
            getReceiverData(flag) {
                if (flag === 'search') {
                    this.receiverParam = {
                        page_index: 1,
                        page_size: 10
                    }
                }

                let success = (res => {
                    this.isScroll = true;
                    this.receiverCount = res.data.data_sum;

                    if (flag === 'scroll') {
                         res.data.data.forEach(item => {
                              this.receiverList.push(item);
                         })
                    } else {
                        document.querySelector('#scrollReceiver') && (document.querySelector('#scrollReceiver').scrollTop = 0);
                        this.receiverList = res.data.data;
                    }
                });
                let fail = (res => {
                    this.isScroll = true;
                    if (flag === 'scroll') {
                        this.receiverParam.page_index--;
                    }
                })
                let appCode = this.plaformList.filter(item => this.plaformId === item.id)[0].app_code;

                this.$ajax({
                    url: "api/email/receiver",
                    method: "get",
                    params: {
                        app_code: appCode,
                        keyword: this.receiver_keyword,
                        page_index: this.receiverParam.page_index,
                        page_size: this.receiverParam.page_size
                    },
                    func: {success: success, fail: fail}
                });
            },
            /**
             * 获取收件人列表
             */
             getReceiverList(flag) {
                document.removeEventListener('scroll', this.scrollFun, false);

                this.$nextTick(() => {
                    let domval = document.querySelector('#scrollReceiver');
                    domval && domval.addEventListener('scroll', this.scrollFun, false);
                })

                this.receiverList = [];
                this.getReceiverData();
            },
            /**
             * 每8分钟自动保存邮件
             */
            setTimers() {
                let _this = this;
                
                this.intervalTime = setInterval(() => {
                    _this.submitDrafts('save');
                }, 480000);
            },
            /**
             * 保存至草稿箱
             */
            submitDrafts(autoName){
                if (this.isSend && autoName !== 'save') {
                    this.$message.warning('附件正在上传，请稍等！');
                    return false;
                }

                this.loading.status = true;

                let userList = [];
                let strMail = this.sendForm.externalRecipient.split(/[,，]/g); 

                this.recipientList.forEach(item => {
                    userList.push({
                        receiver: item.id,
                        receive_type: 1
                    })
                })

                this.ccList.forEach(item => {
                    userList.push({
                        receiver: item.id,
                        receive_type: 2
                    })
                })

                strMail.forEach(item => {
                    if (item != '') {
                        userList.push({
                            receiver: item,
                            receive_type: 3
                        })
                    }
                })

                let params = {
                    id: this.mailId ? this.mailId : 0,
                    subject: this.sendForm.subject,
                    type: 1,
                    obj_id: 0,
                    config_id: this.sendForm.internetMail,
                    content: this.sendForm.post_content,
                    submit_type: 0,
                    user: userList,
                    file: this.sendForm.attachment
                }
                    
                const success = (res => {
                    this.loading.status = false;
                    this.$message.success('邮件已保存至草稿箱');
                    this.mailId = !is_empty(res.data) ? parseInt(res.data) : 0;
                })

                const fail = (res => {
                    this.loading.status = false;
                    this.$message.error(res.msg);
                })

                this.$ajax({
                    url: "api/email/single",
                    method: "post",
                    // headers: {'Content-Type': 'application/json;charset=UTF-8'},
                    // params: params,
                    data: params,
                    func: {success: success, fail: fail}
                });
            },
            /**
             * 获取网络邮箱
             */
            getInternetList() {
                networkMailbox(this).then(res => {
                    this.internetList = res;
                })
            },
            /**
             * 发生邮件
             * @param {String} formName 表单标识
             */
            submitMail(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.isSend) {
                            this.$message.warning('附件正在上传，请稍等！');
                            return false;
                        }

                        if (this.isExternalRecipient) {
                            return false;
                        }

                        this.loading.status = true;

                        let userList = [];
                        let strMail = this.sendForm.externalRecipient.split(/[,，]/g); 

                        this.recipientList.forEach(item => {
                            userList.push({
                                receiver: item.id,
                                receive_type: 1
                            })
                        })

                        this.ccList.forEach(item => {
                            userList.push({
                                receiver: item.id,
                                receive_type: 2
                            })
                        })

                        strMail.forEach(item => {
                            if (item != '') {
                                userList.push({
                                    receiver: item,
                                    receive_type: 3
                                })
                            }
                        })

                        let params = {
                            id: this.mailId ? this.mailId : 0,
                            subject: this.sendForm.subject,
                            type: 1,
                            obj_id: 0,
                            config_id: this.sendForm.internetMail,
                            content: this.sendForm.post_content,
                            submit_type: 1,
                            user: userList,
                            file: this.sendForm.attachment
                        }
  
                        const success = (res => {
                            let _this = this;
                            this.loading.status = false;
                            this.$message.success('邮件发送成功');
                            let mailListId = JSON.parse(sessionStorage.getItem('mailListId'));

                            if (mailListId && mailListId.sent) {
                                sessionStorage.setItem('mailListId', JSON.stringify({...mailListId, ...{sent: parseInt(res.data)}}));
                            } else {
                                sessionStorage.setItem('mailListId', JSON.stringify({sent: parseInt(res.data)}));
                            }
                            
                            setTimeout(() => {
                                _this.$router.push(`/email/sent`);
                            }, 500);
                        })

                        const fail = (res => {
                            this.$message.error(res.msg);
                            this.loading.status = false;
                        })

                        this.$ajax({
                            url: "api/email/single",
                            method: "post",
                            // headers: {'Content-Type': 'application/json;charset=UTF-8'},
                            data: params,
                            func: {success: success, fail: fail}
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 添加收件人
             * @param {String} val 有值为抄送，反之为收件人
             */
            addFormRecipient(val = '') {
                this.pop_up = true;

                if (val === 'cc') {
                    this.recipientCC = true;
                    this.people_lsit = deep_clone(this.ccList);
                } else {
                    this.people_lsit = deep_clone(this.recipientList);
                }

                if (this.plaformList.length > 0) {
                    this.plaformId = this.plaformList[0].id;
                    this.receiver_keyword = null;
                    this.receiverParam = {
                        page_index: 1,
                        page_size: 10
                    }
                    this.getReceiverList();
                }
            },
            /**
             * 添加收件人
             * @param {Number} inx 收件人列表下标
             */
            addRecipient(inx) {
                if (this.people_lsit.length >= 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                // 发件人和抄送人不可以相同
                if (this.recipientCC) {
                    for (let i=0, len=this.recipientList.length; i<len; i++) {
                        if (this.recipientList[i].id === this.receiverList[inx].id) {
                            this.$message.error('发件人和抄送人不可以为同一个用户');
                            return false;
                        }
                    }
                } else {
                    for (let i=0, len=this.ccList.length; i<len; i++) {
                        if (this.ccList[i].id === this.receiverList[inx].id) {
                            this.$message.error('发件人和抄送人不可以为同一个用户');
                            return false;
                        }
                    }
                }

                // 不可重复添加相同人员
                if (!is_empty(this.people_lsit)) {
                    let len = this.people_lsit.length;

                    for (let i=0; i<len; i++) {
                        if (this.people_lsit[i].id === this.receiverList[inx].id) {
                            this.$message.error('不可重复添加相同人员');
                            return false;
                        }
                    }

                    this.people_lsit.push(deep_clone(this.receiverList[inx]));
                } else {
                    this.people_lsit.push(deep_clone(this.receiverList[inx]));
                }

            },
            /**
             * 添加全部收件人 
             */
            addAllRecipient() {
                if (this.people_lsit.length >= 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                
                let _temp = [];

                this.receiverList.forEach(item1 => {
                    let falg = true;
                    let _item = [];

                    // 发送人和抄送人不可以相同
                    if (this.recipientCC) {
                        _item = deep_clone(this.recipientList.filter(item => item.id === item1.id));
                    } else {
                        _item = deep_clone(this.ccList.filter(item => item.id === item1.id));
                    }

                    // 不可重复添加相同人员
                    if (is_empty(_item)) {
                        this.people_lsit.forEach(item2 => {
                            if (item1.id === item2.id) {
                                falg = false;
                            }
                        })

                        falg && _temp.push(item1);
                    }
                })

                if (_temp.length === 0) {
                    this.$message.error('不可重复添加相同人员');
                    return false;
                }

                if (_temp.length + this.people_lsit.length > 20) {
                    this.$message.error('最多只能选择20个用户');
                    return false;
                }

                this.people_lsit = [...deep_clone(this.people_lsit), ...deep_clone(_temp)];
            },
            /**
             * 关闭选择收件人
             */
            closeRecipient() {
                this.pop_up = false;
                this.recipientCC = false;
                this.people_lsit = [];
                this.receiverList = [];
                this.receiver_keyword = null;
                this.receiverParam = {
                    page_index: 1,
                    page_size: 10
                }
            },
            /**
             * 删除选中的收件人
             * @param {Number} inx 选中人员下标
             */
            deleteRecipient(inx) {
                this.people_lsit.splice(inx, 1);
            },
            /**
             * 保存选择的收件人
             */
            newRecipient() {
                if (this.recipientCC) {
                    this.ccList = deep_clone(this.people_lsit);
                    this.recipientCC = false;
                } else {
                    this.recipientList = deep_clone(this.people_lsit);
                    this.sendForm.recipients = 'receiver';
                }

                this.closeRecipient();
            },
            /**
             * 清空收件人
             * @param {String} val 有值为抄送，反之为收件人
             */
            clearRecipient(val) {
                if (val === 'cc') {
                    this.ccList = [];
                } else {
                    this.recipientList = [];
                    this.sendForm.recipients = '';
                }

                this.$message.warning('无收件人');
            },
            /**
             * 删除一个收件人
             * @param {Number} inx 数组下标
             */
            clearReceiver(inx) {
                this.recipientList.splice(inx, 1);
            },
            /**
             * 删除一个抄送收件人
             * @param {Number} inx 数组下标
             */
            clearCC(inx) {
                this.ccList.splice(inx, 1);
            },
            /**
             * 验证外部收件人邮箱是否正确
             */
            blurExternalRecipient() {
                if (is_empty(this.sendForm.externalRecipient)) {
                    return false;
                }

                let temp = this.sendForm.externalRecipient.slice(-1);
                let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                let str = this.sendForm.externalRecipient.split(/[，,]/g);
                let dom = document.querySelector('#external_recipient').classList;

                (temp === ',' || temp === '，') && str.pop();

                dom.remove('external-recipient-success');
                dom.remove('external-recipient-error');

                for (let i=0; i<str.length; i++) {
                    if (!reg.test(str[i])) {
                        this.$message.error(`第${i+1}个外部收件人邮箱格式不正确`);
                        dom.add('external-recipient-error');
                        this.isExternalRecipient = true;
                        return;
                    }
                }

                this.isExternalRecipient = false;
                dom.add('external-recipient-success');
            },
            /**
             * 移除上传的附件
             * @param {String} name 附件名称
             */
            delAttachment(name) {
                this.sendForm.attachment = this.sendForm.attachment.filter(function(item) {
                    return item.name !== name;
                })

                this.$refs.uploader.uploader.fileList = this.$refs.uploader.uploader.fileList.filter(function(item) {
                    return item.name !== name;
                })

                this.$refs.uploader.uploader.files = this.$refs.uploader.uploader.files.filter(function(item) {
                    return item.name !== name;
                })
            },
            /**
             * 过滤附件
             */
            fileAdded(file) {
                if (file.size > 100*1024*1024) {
                    this.$message.error('附件大小为100M内');
                    file.ignored = true;
                    return false;
                }

                this.percentage = 0;
                this.progressing = true;
                this.disabledUplader = true;
            },
            /**
             * 所选择的附件添加到上传队列后触发
             */
            fileSubmit(files, fileList, event){},
            /**
             * 附件上传中
             */
            fileProgress() {
                this.isSend = true;
                this.percentage = parseInt(this.$refs.uploader.uploader.progress() * 100);
            },
            /**
             * 取消上传
             */
            fileCancel() {
                this.$refs.uploader.uploader.cancel();
                this.disabledUplader = false;
            },
            /**
             * 移除附件
             */
            fileRemoved(file) {
                this.isSend = false;
                this.progressing = false;
                this.disabledUplader = false;
            },
            /**
             * 上传附件成功
             */
            fileSuccess(rootFile, file, message, chunk) {
                this.progressing = false;
                this.disabledUplader = false;
                this.isSend = false;

                let mess = eval("(" + message + ")");
                mess = handleResponseData(mess);
                this.sendForm.attachment.push({
                    path: mess.data.file_path,
                    // type: mess.data.file_type,
                    name: mess.data.file_name,
                    postfix: mess.data.post_fix
                })
            },
            /**
             * 上传附件失败
             */
            fileFail(rootFile, file, message, chunk) {
                this.progressing = false;
                this.isSend = false;
                let mess = eval("(" + message + ")");

                if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
                    let callbcak = data => {
                        this.uploadRetryTimes--;
                        this.$refs.uploader.uploader.retry(file);
                    };
                    this.get_access_token(callbcak);
                } else {
                    this.disabledUplader = false;
                    this.$message.error(mess.msg);
                }
            },
            /**
             * 改变元素的样式
             */
            setStyle() {
                // footer
                this.home_header = document.querySelector('#front_email .headder').classList;
                this.home_main = document.querySelector('#front_email .main').classList;
                this.home_header.add('hidden-header');
                this.home_main.add('hidden-main');
            },
            /**
             * 返回上一个页面
             */
            linkTo() {
                this.$router.go(-1);
            },
            /**
             * 编辑器初始化
             */
            editorInit() {
                // 修改输入框内文字与边界的宽
                let dom = document.getElementById('d1_ifr').contentWindow.document.getElementById('tinymce');
                dom.style.margin = "8px 25px 80px";

                //监听粘贴事件，去除图片标签
                dom.addEventListener('paste', function (e) {
                    
                }, false)
            },
            /**
             * 编辑器图片上传
             * @param {bolb} blobInfo 图片数据
             * @param {Function} success 成功时的回调函数
             * @param {Function} failure 失败时的回调函数
             */
            images_upload_handler(blobInfo, success, failure) {
                if (blobInfo.blob().type.indexOf("image/") === -1) {
                    failure("只允许上传图片格式的文件");
                // } else if (blobInfo.blob().size > 2048000) {
                //     failure("图片大小不能超过2M");
                } else {
                    let formData = new FormData();
                    formData.append("file", blobInfo.blob(), blobInfo.filename());
                    let succ = data => {
                        data.data=data.data.data;
                        success(this.BASE_URL + data.data.data.file_path);
                    };
                    let fail = data => {
                        data.data=data.data.data;
                        failure(data.data.data.message);
                    };

                    /****************** 不知为何要重新create *****************/
                    const instance = axios.create({
                        headers: {
                            Authorization: `Bearer ${this.$g.access_token}`,
                            DecisionPlatform: ` ${this.$g.access_token}`,
                            token: localStorage.getItem("token")
                        },
                        withCredentials: true
                    });

                    instance.post("api/resource/res_upload", formData)
                    .then(succ)
                    .catch(fail);
                }
            },
        },
        beforeDestroy() {
            // 清空本页面特有的样式
            this.home_header.remove('hidden-header');
            this.home_main.remove('hidden-main');

            clearInterval(this.intervalTime);
        }
    }
</script>

<style lang="scss">
    .hidden-header {
        display: none;
    }
    
    .hidden-main {
        height: calc(100vh - 59px);        
    }

    .send-mail {
        position: relative;
        width: 100%;
        height: 100%;
        max-width: 1920px;
        overflow-y: auto;

        .add-recipients-dialog {
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }

            .el-dialog-pop-up {
                display: flex;

                >div:first-child {
                    width: 270px;

                    .el-select {
                        width: 255px;
                    }

                    .org-people-box {
                        >div {
                            margin-top: 20px;
                            margin-right: 15px;
                            height: 290px;
                            border: 1px solid #DDDDDD;
                            overflow: hidden;
                            overflow-y: auto;

                            .org-people-item {
                                display: flex;
                                align-items: center;
                                padding: 10px 15px;
                                font-size: 12px;

                                span:first-child {
                                    width: 110px;
                                    // overflow: hidden;
                                    // text-overflow: ellipsis;
                                    // white-space: nowrap;
                                }

                                span:nth-child(2) {
                                    flex: 1;
                                }

                                span:last-child {
                                    font-size: 12px;
                                    width: 35px;
                                    color: #3D70AF;
                                    text-align: center;
                                    cursor: pointer;
                                }
                            }
                        }

                        >p {
                            width: 255px;
                            height: 38px;
                            line-height: 38px;
                            color: #348EFC;
                            font-size: 12px;
                            text-align: center;
                            border: 1px solid #DDDDDD;
                            border-top: none;
                            box-sizing: border-box;
                            cursor: pointer;
                        }
                    }
                }

                >div:last-child {
                    flex: 1;

                    .el-dialog-pop-keyword {
                        .el-input {
                            margin-right: 10px;
                            width: 242px;
                        }

                        button {
                            width: 82px;
                        }
                    }

                    .el-show-pepole {
                        >div {
                            margin-top: 20px;
                            height: 290px;
                            font-size: 12px;
                            border: 1px solid #DDDDDD;
                            overflow: hidden;
                            overflow-y: auto;

                            >div:first-child{
                                height: 36px;
                                line-height: 36px;
                            }

                            >div:not(:first-child) {
                                margin: 16px 0;
                            }

                            >div {
                                span {
                                    display: inline-block;
                                }

                                span:first-child {
                                    width: 30px;

                                    i {
                                        color: #D8D8D8;
                                        font-size: 16px;
                                    }
                                }

                                span:nth-child(2) {
                                    width: 170px;
                                }

                                span:nth-child(3) {
                                    width: 114px;
                                }

                                span:nth-child(4) {
                                    width: 94px;
                                }
                            }

                            >div:first-child {
                                background: #F5F5F5;
                            }

                            >div:not(:first-child) {
                                span:first-child {
                                    text-align: center;
                                    visibility: hidden;
                                    cursor: pointer;
                                }
                            }

                            >div:not(:first-child):hover {
                                span:first-child {
                                    visibility: visible;
                                }
                            }
                        }

                        >p {
                            width: 540px;
                            height: 38px;
                            line-height: 38px;
                            color: #348EFC;
                            font-size: 12px;
                            text-align: center;
                            border: 1px solid #DDDDDD;
                            border-top: none;
                            box-sizing: border-box;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .send-mail-title {
            position: fixed;
            padding-left: 60px;
            width: 100%;
            height: 80px;
            line-height: 80px;
            background: #fff;
            border-top: 1px solid #eee;
            border-bottom: 1px solid #eee;
            z-index: 10;

            >span {
                font-size: 18px;
                cursor: pointer;
            }

            >span:before {
                display: inline-block;
                content: "";
                position: absolute;
                top: 35px;
                left: 40px;
                width: 10px;
                height: 10px;
                border-width: 0 0 2px 2px;
                border-color: #888;
                border-style: solid;
                transform: rotateZ(45deg);
            }
        }

        .send-mail-main {
            margin-top: 80px;
            padding: 30px 70px 90px 50px;
            height: calc(100% - 160px);
            background: #fff;
            box-sizing: border-box;
            overflow-y: auto;

            .demo-send-form {
                .disabled-uploader {
                    padding: 7px 8px;
                    color: #fff;
                    border-radius: 5px;
                    border: 1px solid #ccc;
                    background: #ccc;
                }

                .uploader-example {
                    .uploader-btn {
                        color: #fff;
                        border-radius: 4px;
                        border: 1px solid #8199C7;
                        background: #8199C7;
                    }

                    .uploader-progress {
                        display: none;
                    }

                    .uploader-progress-active {
                        display: inline-block;
                        margin-left: 30px;
                        font-size: 14px;

                        >div {
                            display: flex;
                            align-items: center;

                            >div {
                                width: 200px;
                            }

                            >span:nth-child(2) {
                                margin-left: 16px;
                                color: #348EFC;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .tinymce-num {
                    position: absolute;
                    right: 0;
                    bottom: 1px;
                    display: block;
                    padding-right: 35px;
                    width: calc(100% - 1px);
                    text-align: right;
                    font-size: 12px;
                    color: #999;
                    background: #F9F9F9;
                    box-sizing: border-box;
                }

                .el-input input {
                    font-size: 15px;
                    color: #000;
                }

                .external-recipient-success {
                    color: #348EFC;
                    border: 1px solid #348EFC;
                }

                .external-recipient-error {
                    color: #F56C6C;
                    border: 1px solid #F56C6C;
                }

                #d1_ifr {
                    height: 426px !important;
                }

                .mail-content {
                    >div {
                        position: relative;
                    }

                    .content-tip-hidden {
                        display: none !important;
                    }

                    .mce-statusbar.mce-container.mce-panel.mce-stack-layout-item.mce-last {
                        display: none;
                    }
                }
                
                .mce-tinymce.mce-container.mce-panel[role=application] >div >div:first-child >div >div:first-child   {
                    display: none;
                }

                .mce-tinymce.mce-container.mce-panel[role=application] >div >div:first-child >div >div:last-child >div >div:first-child {
                    display: none;
                }
            }

            .send-form-recipients .el-form-item__content >div:first-child {
                display: inline-block;
                width: calc(100% - 182px);
            }

            .send-form-cc,
            .send-form-recipients .el-form-item__content >div:first-child {
                padding-left: 16px;
                padding-right: 16px;
                font-size: 12px;
                color: #999999;
                background: #F9F9F9;
                border: 1px solid #DDDDDD;
                border-radius: 4px;
                cursor: default;
                box-sizing: border-box;

                >span {
                    margin-right: 10px;
                    padding: 11px 0;
                    font-size: 14px;
                    cursor: pointer;

                    >i {
                        padding-left: 5px;
                        color: #ccc;
                    }
                }

                >span:last-child {
                    >span {
                        display: none;
                    }
                }

                >span:hover {
                    color: #000;
                    
                    i {
                        color: #C77676;
                    }
                }
            }

            .send-form-internet .el-form-item__content {
                .el-select {
                    width: 400px;
                }

                >span {
                    margin-left: 20px;
                    font-size: 12px;
                    color: #666666;
                }
            }

            .send-form-attachment-list {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                >span {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-right: 30px;
                    font-size: 14px;
                    color: #586F8B;

                    span {
                        padding: 0 12px 0 8px;
                    }

                    i {
                        font-size: 18px;
                        color: #ccc;
                        cursor: pointer;
                    }

                    i:hover {
                        color: #C77676;
                    }
                }
            }

            .no-attachment {
                font-size: 12px;
                color: #999999;
            }

            .send-form-reciver {
                display: inline-block;

                span {
                    font-size: 12px;
                    color: #3D70AF;
                    cursor: pointer;
                }
                
                >span:first-child {
                    margin-left: 30px;
                }

                >span:last-child {
                    margin-left: 20px;
                }
            }

            .send-form-btn {
                span {
                    padding: 7px 10px;
                    font-size: 12px;
                    color: #fff;
                    border-radius: 4px;
                    cursor: pointer;
                }

                span:first-child {
                    background: #708DC4;
                }

                span:last-child {
                    margin-left: 10px;
                    background: #C77676;
                }
            }
        }

        .send-mail-footer {
            position: fixed;
            bottom: 60px;
            width: 100%;
            height: 80px;
            line-height: 80px;
            text-align: center;
            background: #F9F9F9;

            >span:first-child {
                font-size: 14px;
                color: #999999;
                cursor: pointer;
            }

            >span:last-child {
                margin-left: 40px;
                padding: 6px 12px;
                font-size: 14px;
                color: #fff;
                background: #348EFC;
                border-radius: 2px;
                cursor: pointer;
            }

            span {
                vertical-align: middle;

                img {
                    margin-right: 8px;
                    vertical-align: middle;
                }
            }
        }
    }
</style>